module.exports = __webpack_public_path__ + "media/images/image_sonaeru-365acdfc48b85f0e4233d12104d195f9.jpeg";